// src/balanceSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

interface FetchBalanceParams {
  playerId: string;
  currency: string;
}

// Async thunk to fetch balance
export const fetchBalance = createAsyncThunk<
  any,
  FetchBalanceParams
>("balance/fetchBalance", async (params, { rejectWithValue }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BINGO_PMS_API_URL}/wapas/balance/get-detailed-transaction-profile`,
      params
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const balanceSlice = createSlice({
  name: "balance",
  initialState: {
    balance: {
      cash: 0.0,
      coins: 0.0,
      currencyCode: "",
      valueType: "",
    },
    loading: false,
    error: null as any,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBalance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.balance = action.payload;
      })
      .addCase(fetchBalance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

const balanceData = (state) => state.balanceData.balance;
const balanceError = (state) => state.balanceData.error;
const balanceLoading = (state) => state.balanceData.loading;

export { balanceData, balanceError, balanceLoading };
export default balanceSlice.reducer;
